// extracted by mini-css-extract-plugin
module.exports = {"root":"index__jloUR40A"};